import ReactGA from 'react-ga'

class AnalyticsService {
  // ─── Legacy UA + GTM event (kept for backward compatibility) ────────────
  sendEvent = (category, action, label, gtmObject) => {
    ReactGA.event({
      category,
      action,
      label
    })
    window.dataLayer.push(gtmObject)
  }

  // ─── Generic GA4 dataLayer push (existing usage) ───────────────────────
  sendGa4Event = (gtmObject) => {
    window.dataLayer.push(gtmObject)
  }

  // ─── NEW: Standardised GA4 funnel event ─────────────────────────────────
  //
  // Pushes a well-structured event object to the GTM dataLayer.
  //
  // @param {string} eventName  – One of the constants from ga4Events.js
  //                              (e.g. "insider_landing_page_viewed").
  // @param {Object} [params]   – Additional event parameters such as
  //                              { customer_type, page_path, … }.
  //                              Must NOT contain PII.
  // ────────────────────────────────────────────────────────────────────────
  sendGA4FunnelEvent = (eventName, params) => {
    if (!eventName || typeof eventName !== 'string') {
      console.warn('[AnalyticsService] sendGA4FunnelEvent called without a valid eventName')
      return
    }

    // Build a clean parameter object – drop null / undefined values
    var cleanParams = {}
    if (params && typeof params === 'object') {
      var keys = Object.keys(params)
      for (var i = 0; i < keys.length; i++) {
        var key = keys[i]
        if (params[key] != null) {          // deliberately loose check (null & undefined)
          cleanParams[key] = params[key]
        }
      }
    }

    var payload = Object.assign({}, cleanParams, { event: eventName })

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(payload)
  }

  
  sendUniquePageview = (page) => {
    
    const dataLayer = window.dataLayer

    // Record unique pageviews in an array
    let uniquePageviews = window.sessionStorage.getItem("unique-pageviews");
    if (uniquePageviews) {
      uniquePageviews = JSON.parse(uniquePageviews);
    } else {
      uniquePageviews = [];
    }
  
    // Don't continue if the current page has already been viewed in this session
    if (uniquePageviews.indexOf(page) !== -1) {
      return;
    }
  
    // Track a pageview for a newly visited URL in this session
    uniquePageviews.push(page);
    uniquePageviews = JSON.stringify(uniquePageviews);
    window.sessionStorage.setItem("unique-pageviews", uniquePageviews);
  
    // Send "unique_page_view" event to GA4
    const properties = {
      event: "unique_page_view",
      page_location: page,
    };
    dataLayer.push(properties);
  
    // Debug helper (optional)
    console.log(`"unique_page_view" tracked in GA4`, properties);
 }
}
export default new AnalyticsService()
